import { useCallback } from 'react';
import { useUnit } from 'effector-react';
import { useDebounce } from '@nx-frontend/shared/hooks';
import { PaywallAddonCardPropsWithLoc } from '@nx-frontend/shared/types/paywall-types';
import { PaywallAddonCard } from './paywall-addon-card';
import { $paywallStore, changeAddonCountEvent, fetchOrderSummaryEvent } from './store';

export const PaywallAddonCardWrapper = (props: PaywallAddonCardPropsWithLoc) => {
  const { code, selected } = props;

  const [paywallState] = useUnit([$paywallStore]);
  const [changeAddonCount, fetchOrderSummary] = useUnit([changeAddonCountEvent, fetchOrderSummaryEvent]);

  // important to use useCallback for debounced functions
  // if not, it will be recreated on every render
  const selectPlanCallback = useCallback(() => {
    fetchOrderSummary();
  }, [fetchOrderSummary]);

  const selectPlanDebounce = useDebounce<void>(selectPlanCallback, 600);

  const handleCounterChange = useCallback(
    (quantity: number) => {
      changeAddonCount({ code, quantity });
      if (quantity || Object.keys(paywallState.selectedAddons).length) {
        selectPlanDebounce();
      }
    },
    [code, selectPlanDebounce, paywallState.selectedAddons, changeAddonCount]
  );

  /**
   * Handle AI addon button click
   */
  const handleAddButtonClick = useCallback(() => {
    changeAddonCount({ code, quantity: selected ? 0 : paywallState.onlyMembersCnt });
    selectPlanDebounce();
  }, [code, selected, selectPlanDebounce, paywallState.onlyMembersCnt, changeAddonCount]);

  return <PaywallAddonCard {...props} onCounterChange={handleCounterChange} onAddButtonClick={handleAddButtonClick} />;
};
